import * as actionTypes from "../ActionTypes";

// ✅ Save Program Language Meta
export const saveProgramLanguageMetaRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_PROGRAM_LANGUAGE_META_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveProgramLanguageMetaSuccess = (data) => ({
  type: actionTypes.SAVE_PROGRAM_LANGUAGE_META_SUCCESS,
  payload: data,
});

export const saveProgramLanguageMetaFailure = (error) => ({
  type: actionTypes.SAVE_PROGRAM_LANGUAGE_META_FAILURE,
  payload: error,
});
